import { render, staticRenderFns } from "./ProductModifiers.vue?vue&type=template&id=d04a35a8&scoped=true&"
import script from "./ProductModifiers.vue?vue&type=script&lang=js&"
export * from "./ProductModifiers.vue?vue&type=script&lang=js&"
import style0 from "./ProductModifiers.vue?vue&type=style&index=0&id=d04a35a8&prod&lang=scss&scoped=true&"
import style1 from "./ProductModifiers.vue?vue&type=style&index=1&id=d04a35a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04a35a8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconSubtract: require('/opt/build/repo/components/icons/IconSubtract.vue').default,IconAdd: require('/opt/build/repo/components/icons/IconAdd.vue').default})
